import React from 'react';
import { Box, type NestedListRowData } from '@saviynt/design-system';
import cx from 'classnames';

import './CustomNestedRow.css';

interface CustomNestedRowProps {
  rowsData: NestedListRowData[];
  level?: number;
}

/**
 * CustomNestedRow
 */
function CustomNestedRow({ rowsData, level }: CustomNestedRowProps) {
  if (rowsData.length === 0) {
    return null;
  }

  return rowsData.map((row) => (
    <Box
      key={row.id}
      tag='div'
      className={cx(
        'CustomNestedRow-wrapper',
        `CustomNestedRow-wrapper--isLevel${level ?? '0'}`
      )}>
      <Box
        tag='div'
        className={cx(
          'CustomNestedRow-coreTile',
          `CustomNestedRow-coreTile--isLevel${level ?? '0'}`
        )}>
        {row.leadingComp}
        {row.centerContent}
        {row.trailingContent}
      </Box>
      {row.childRows && row.childRows.length > 0 && level === 0 && (
        <Box tag='div' className={cx('CustomNestedRow-childWrapper')}>
          <CustomNestedRow rowsData={row.childRows} level={level + 1} />
        </Box>
      )}
    </Box>
  ));
}

CustomNestedRow.defaultProps = {
  level: 0,
};

export default CustomNestedRow;
